import { useParams } from "react-router";
import { MdOutlinePlaylistPlay } from "react-icons/md";
import { useFontStyle } from "~/hook/useFontStyle";
import useLocale from "~/hook/useLocale";
import { cn } from "~/lib/utils";
import { BLUR_HASH, COLORS, FALLBACK_IMAGE_ALT_TEXT, FALLBACK_IMAGE_URL } from "~/utils/constant";
import { convertSecondsToHMS, isMediaAudioOnly } from "~/utils/helper-funcations";
import { RELATED_PLAYLIST_QUERY } from "../audio-video/RelatedPlaylist";
import ClientOnly from "../shared-components/ClentOnly";
import ImageWithSkeleton from "../shared-components/ImageWithSkeleton";
import PlayListChip from "./PlayListChip";
import { DifferentComponentDetailsType } from "./type";
import { DISPLAY_TYPE } from "./video-data";

type PropsType = {
  item: DifferentComponentDetailsType;
  url_slug: string | null;
  isBranch: boolean;
  playlist_slug?: string | null;
  isRelated?: boolean;
};

const RenderCircleItem = ({ item, url_slug, playlist_slug, isBranch, isRelated = false }: PropsType) => {
  const { LocalizedLink } = useLocale();
  const { normalInter } = useFontStyle();
  const { video_category } = useParams();

  let URL = isBranch
    ? playlist_slug
      ? `/${video_category}/${url_slug}/${playlist_slug}/${item.url_slug}`
      : `/${video_category}/${url_slug}/${item.url_slug}`
    : item.url_slug
      ? `/${video_category}/${url_slug}/${item.url_slug}`
      : `/${video_category}/${url_slug}`;

  if (isRelated) {
    URL = URL + `?${RELATED_PLAYLIST_QUERY}=playlist`;
  }
  const ImageCard = () => (
    <ImageWithSkeleton
      url={{
        small: item?.square_img?.s?.url || item?.img?.s?.url || FALLBACK_IMAGE_URL,
        medium: item?.square_img?.m?.url || item?.img?.m?.url || FALLBACK_IMAGE_URL,
        large: item?.square_img?.l?.url || item?.img?.l?.url || FALLBACK_IMAGE_URL,
        hd: item?.square_img?.hd?.url || item?.img?.hd?.url || FALLBACK_IMAGE_URL,
        original: item?.square_img?.og?.url || item?.img?.og?.url || FALLBACK_IMAGE_URL,
      }}
      alt={item.name || FALLBACK_IMAGE_ALT_TEXT}
      blur_hash={item.img?.bh || BLUR_HASH}
      className="h-full w-full object-cover"
      isPreloaded={true}
    />
  );

  return (
    <LocalizedLink
      to={URL}
      query={!item.node_type ? { watch: item.id, media: item?.media_type ? isMediaAudioOnly(item?.media_type) : undefined } : undefined}
      className="flex flex-col items-center text-center xs:gap-y-2 md:gap-y-3 w-full"
    >
      <div className="aspect-square w-full  max-w-[100px] sm:max-w-[140px] md:max-w-[160px] lg:max-w-[150px] 2xl:max-w-[170px] rounded-full overflow-hidden relative border border-gray-200 shadow-md shadow-textHeadingColor flex-shrink-0 mx-auto">
        <ClientOnly fallback={<ImageCard />}>
          <ImageCard />
        </ClientOnly>

        <div className="absolute bottom-1 left-1">
          {item.node_type === DISPLAY_TYPE.playlist_series ? (
            <PlayListChip icon={<MdOutlinePlaylistPlay color={COLORS.white} size={14} />} text={`${item?.total_playlist_item} Videos`} />
          ) : (
            <PlayListChip text={convertSecondsToHMS(item.duration_sec!)} />
          )}
        </div>
      </div>

      <p className={cn("body_text_m text-textColorPrimary line-clamp-2 leading-5 w-full px-1", normalInter)} title={item.name}>
        {item.name}
      </p>
    </LocalizedLink>
  );
};

export default RenderCircleItem;
